module.exports = __webpack_public_path__ + "c4cda5520fad8b3f332a8ddaa2206360.png";